/* =====================================================================
   Mobile drawer: auto-expand the "Shop" sub-menu the moment the drawer
   opens so users land on Shop categories instead of needing an extra tap.
   (Added 2026-06-25.)
   ===================================================================== */
(function () {
  var TARGET_TITLE = 'shop';
  var OBSERVED = new WeakSet();

  function findShopButton(drawer) {
    var buttons = drawer.querySelectorAll('.sliderow[data-sliderule-open]');
    for (var i = 0; i < buttons.length; i++) {
      var t = buttons[i].querySelector('.sliderow__title');
      if (t && t.textContent.trim().toLowerCase() === TARGET_TITLE) return buttons[i];
    }
    return null;
  }

  function panelAlreadyOpen(drawer) {
    return !!drawer.querySelector(
      '.sliderule__panel.is-visible, .sliderule__panel[aria-hidden="false"]'
    );
  }

  function tryExpandShop(drawer) {
    if (panelAlreadyOpen(drawer)) return;
    var btn = findShopButton(drawer);
    if (btn) btn.click();
  }

  function watchDrawer(drawer) {
    if (OBSERVED.has(drawer)) return;
    OBSERVED.add(drawer);
    var mo = new MutationObserver(function () {
      var open =
        drawer.classList.contains('is-visible') ||
        drawer.getAttribute('aria-hidden') === 'false' ||
        drawer.dataset.drawerOpen === 'true';
      if (open) {
        setTimeout(function () { tryExpandShop(drawer); }, 50);
      }
    });
    mo.observe(drawer, {
      attributes: true,
      attributeFilter: ['class', 'aria-hidden', 'data-drawer-open']
    });
  }

  function init() {
    var drawer = document.querySelector('.drawer--header[data-drawer="hamburger"]');
    if (drawer) watchDrawer(drawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener(
    'click',
    function (e) {
      var toggle = e.target.closest('[data-drawer-toggle="hamburger"]');
      if (!toggle) return;
      var drawer = document.querySelector('.drawer--header[data-drawer="hamburger"]');
      if (!drawer) return;
      setTimeout(function () { tryExpandShop(drawer); }, 350);
    },
    true
  );
})();